import CRUD from './genericCRUD'

const route = 'commodities'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function commodities(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 * @param {string} name
		 * @param {string} code
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (pageNumber, pageSize, name, code, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const nameParam = name ? `name=${name}&` : ''
			const codeParam = code ? `code=${code}&` : ''

			return instance.get(`${route}?${params}${nameParam}${codeParam}`, config)
		}
	}
}
